import React from 'react';

function Square(){
    return(
        <svg version="1.1" id="square" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
            viewBox="0 0 50 50">

        <rect x="7.4" y="8.5" transform="matrix(0.9397 -0.342 0.342 0.9397 -7.2132 9.8369)" className="st0" width="33.8" height="33.8"/>
        </svg>
    )
}

export default Square;